import React, { useState } from 'react';
import { Marker } from '@react-google-maps/api';
import TrafficInfoWindow from '../infoWindows/TrafficInfoWindow';

/**
 * Returns a colour based on AADT value.
 */
const getAadtColor = (aadt) => {
  if (aadt > 60000) return '#ef4444'; // red
  if (aadt > 30000) return '#f97316'; // orange
  if (aadt > 15000) return '#eab308'; // yellow
  return '#22c55e';                   // green
};

const TrafficSensorLayer = ({ sensors = [] }) => {
  const [selected, setSelected] = useState(null);

  return (
    <>
      {sensors.map((sensor, idx) => {
        const lat = sensor.location?.lat ?? sensor.latitude;
        const lon = sensor.location?.lon ?? sensor.location?.lng ?? sensor.longitude;
        if (lat == null || lon == null) return null;

        const position = { lat: Number(lat), lng: Number(lon) };
        const aadt = sensor.latest_aadt || 0;
        const color = getAadtColor(aadt);

        return (
          <Marker
            key={sensor.station_id || `sensor-${idx}`}
            position={position}
            onClick={() => setSelected({ sensor, position })}
            icon={{
              path: window.google?.maps?.SymbolPath?.CIRCLE || 0,
              scale: 7,
              fillColor: color,
              fillOpacity: 1,
              strokeColor: '#fff',
              strokeWeight: 2,
            }}
            title={`${sensor.station_id || 'Sensor'} — ${aadt.toLocaleString()} AADT`}
          />
        );
      })}

      {selected && (
        <TrafficInfoWindow
          sensor={selected.sensor}
          position={selected.position}
          onClose={() => setSelected(null)}
        />
      )}
    </>
  );
};

export default TrafficSensorLayer;
